export class EmployeeDetails {

    id: string;
    domains: any[];
    email: string;
    firstName: string;
    lastName: string;
    department: any;
    roles: any[];
    phoneNumbers: any[];
    active: boolean;
    activeInitial: boolean;

    constructor() {
        this.domains = [{}];
        this.department = {};
        this.phoneNumbers = [];
        this.roles = [];
        this.active = false;
    }
}


// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/employees/form/employee-details.model.ts